import { useAppSelector } from '@/redux/hooks'
import { useTheme } from '@/ui/theme'
import { computeColors } from '@/utils/color-palette-generator'
import { SimplifiedLoginLayout } from '@/app/login/simplified-login-layout'
import { VerticalLoginLayout } from '@/app/login/vertical-login-layout'
import { HorizontalLoginLayout } from '@/app/login/horizontal-login-layout'
import { PbBrandingLayoutDesignValuesEnum } from '@itsrever/rever-api'

const getLoginLayout = (
  design: PbBrandingLayoutDesignValuesEnum | undefined,
  children: React.ReactNode
) => {
  switch (design) {
    case 'VERTICAL':
      return <VerticalLoginLayout>{children}</VerticalLoginLayout>
    case 'SIMPLIFIED':
      return <SimplifiedLoginLayout>{children}</SimplifiedLoginLayout>
    default:
      return <HorizontalLoginLayout>{children}</HorizontalLoginLayout>
  }
}

// LandingLayout is the merchant's landing, with children in place of the login form.
export const LandingLayout = ({ children }: { children?: React.ReactNode }) => {
  const design = useAppSelector(
    (store) =>
      store.settingsApi.settings.response.branding?.layout_design_values
  )

  const theme = useTheme()

  computeColors(theme.colors.primary.main)

  return getLoginLayout(design, children)
}

export const LoginPage = () => <LandingLayout />
